import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { LooksListingResponse, LooksListingFilterParams, NoLooksFoundResponse } from './types';

export const fetchLooksPageActions = createAsyncAction(
    '@LOOKS_LISTINGPAGE/FETCH_START',
    '@LOOKS_LISTINGPAGE/FETCH_SUCCESS',
    '@LOOKS_LISTINGPAGE/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<LooksListingResponse>, DefaultErrorPayload>();

export const resetLooksListingAction = createAction('@LOOKS_LISTINGPAGE/RESET');

export const fetchLooksListingIfNeeded = (params: LooksListingFilterParams): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    let reset = false;
    const previouslySelectedRoom = getState().looksPage.looks?.filters?.rooms.find(r => r.isSelected);
    const previouslySelectedStyle = getState().looksPage.looks?.filters?.styles.find(r => r.selected);
    const previouslySelectedRoomSlug = previouslySelectedRoom?.slug;
    const previouslySelectedStyleSlug = previouslySelectedStyle?.slug;

    if (previouslySelectedRoomSlug !== params.room || previouslySelectedStyleSlug !== params.style) {
        reset = true;
    }

    const identifier = JSON.stringify(params);
    if (identifier === getState().looksPage.identifier) {
        return;
    }

    if (getState().looksPage.looks?.orderedListing[params.page] && !reset) {
        return;
    }

    dispatch(fetchLooksPageActions.request({ identifier }));
    try {
        const looks = await apiService.shopApi.getLooksListings(params);
        dispatch(fetchLooksPageActions.success({ data: looks, identifier, reducerPayloadOptions: { reset } }));
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchLooksListingIfNeeded');
        dispatch(fetchLooksPageActions.failure({ error: err, identifier }));
    }
};

export const fetchNoLooksFoundActions = createAsyncAction(
    '@LOOKS_NOTFOUND/FETCH_START',
    '@LOOKS_NOTFOUND/FETCH_SUCCESS',
    '@LOOKS_NOTFOUND/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<NoLooksFoundResponse>, DefaultErrorPayload>();

export const fetchNoLooksFoundIfNeeded = (): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    if (getState().looksPage.noLooksFound.title) {
        return;
    }
    const identifier = 'fetchNoLooksFoundIfNeeded';
    dispatch(fetchNoLooksFoundActions.request({ identifier }));
    try {
        const data = await apiService.shopApi.getNoLooksFound();
        dispatch(fetchNoLooksFoundActions.success({ data, identifier }));
    } catch (err) {
        log404ErrorAsWarning(err, '', logger, 'fetchNoLooksFoundIfNeeded');
        dispatch(fetchNoLooksFoundActions.failure({ error: err, identifier }));
    }
};

export type LooksPageActionsType =
    | ActionType<typeof fetchLooksPageActions>
    | ActionType<typeof fetchNoLooksFoundActions>
    | ActionType<typeof resetLooksListingAction>;
